/**
 * Created by mohameds on 5/7/19.
 */
import React, {Component} from 'react'
import {HorizontalBar} from 'react-chartjs-2';
import {defaults} from 'react-chartjs-2'
import loadingGIF from "../../public/assets/images/loading.gif";
import {MonitorConst} from './Constants'
import 'chartjs-plugin-datalabels';

const label = {
    label: 'Actual',
    backgroundColor: '#28a745',
    borderColor: '#8e2c2c',
    borderWidth: 1,
};

class AgencyChart extends Component {
    state = {
        pageData: {},
        loading: false,
        data: {
            labels: [],
            datasets: [
                {
                    label: 'Goal',
                    backgroundColor: '#8e2c2c',
                    borderColor: '#8e2c2c',
                    borderWidth: 1,
                    data: []
                }
            ]
        },
    };

    componentDidMount = () => {
        defaults.global.defaultFontSize = 26;
        this.setState({loading: true}, () => {
            this.getPageData()
        })

    };

    componentDidUpdate = (prevProps) => {
        if (prevProps.keyValue !== this.props.keyValue) {
            this.getPageData();
        }
    };

    getPageData = async() => {
        try {
            let res = await this.props.actions.MonitorPage.getIndividualPageData(this.props.pageObj);
            if (res) {
                this.setState({
                    pageData: this.props.agencyMonitor.individualPageData,
                    loading: false
                }, () => {
                    this.getChartValue();
                })
            }
        }
        catch (error) {
        }
    };

    getChartValue = () => {
        const pageData = Object.assign({}, this.state.pageData);
        const data = Object.assign({}, this.state.data);
        const datasets = Object.assign([], this.state.data.datasets);
        const goal = pageData.kpi_list.map(value => {
            if (value.data_type === MonitorConst.CurrencyType.CURRENCY) {
                return Math.round((value.goal / 1000) * 100) / 100;
            }
            return value.goal
        });
        const actual = pageData.kpi_list.map(value => {
            if (value.data_type === MonitorConst.CurrencyType.CURRENCY) {
                return Math.round((value.actual / 1000) * 100) / 100;
            }
            return value.actual
        });
        if (pageData.goal) {
            datasets[0].data = goal;
            datasets[1] = label ;
            datasets[1].data = actual;
        }
        else {
            datasets[0].label = 'Actual';
            datasets[0].backgroundColor = '#28a745';
            datasets[0].borderColor = '#8e2c2c';
            datasets[0].data = actual;
        }

        const labels = pageData.kpi_list.map(value => value.name);
        data.labels = labels;
        data.datasets = datasets;
        this.setState({data})
    };

    componentWillUnmount = () => {
        defaults.global.defaultFontSize = 12;
    };

    getValue = (value, context) => {
        const {pageData} = this.state;
        let chartValue = '';
        if (value !== 0) {
            chartValue = value;
        }
        let kpi_value =
            pageData.kpi_list && pageData.kpi_list.filter(val => context.chart.data.labels[context.dataIndex] === val.name)
        if (kpi_value && kpi_value.length > 0) {
            if (kpi_value[0].data_type === MonitorConst.CurrencyType.CURRENCY) {
                chartValue = '$' + value + 'k'
            }
            if (kpi_value[0].data_type === MonitorConst.CurrencyType.PERCENTAGE) {
                chartValue = value + '%'
            }
        }
        return chartValue;
    }

    render() {
        const {pageData,} = this.state;
        const {settings} = this.props;

        return (
            <div className="container-fluid my-1">
                {this.state.loading ?
                    <div className="text-center" style={{position: 'relative', top: '50%'}}>
                        <img src={loadingGIF} alt="loading..." width="64"/>
                    </div>
                    :
                    <React.Fragment>
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="display-6 font-weight-bold">
                                    {pageData && pageData.title && pageData.title}
                                </p>
                                <span className="hor-bar"/>
                            </div>
                            <HorizontalBar
                                id="my-chart-2"
                                data={this.state.data}
                                width={275}
                                height={100}
                                options={{
                                    maintainAspectRatio: true,
                                    plugins: {
                                        datalabels: {
                                            formatter: (value, context) => this.getValue(
                                                value, context),
                                            anchor: 'end',
                                            align: 'right',
                                            offset: 2
                                        },
                                    }
                                }}
                            />
                        </div>

                    </React.Fragment>
                }
            </div>

        )
    }
}
export default AgencyChart


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/AgencyChart.js